(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivaro-header-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-rv-search]');
    if (!root) return;
    var icon = root.querySelector('[data-rv-search-icon]');
    var panel = root.querySelector('[data-rv-search-panel]');
    var input = root.querySelector('[data-rv-search-input]');
    var results = root.querySelector('[data-rv-search-results]');
    var closeBtn = root.querySelector('[data-rv-search-close]');

    function isDesktop() {
      return window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
    }

    /* --- Posicionar el panel mobile justo debajo del header --- */
    function positionPanel() {
      if (isDesktop()) { panel.style.top = ''; return; }
      var host = icon.closest('.shopify-section') || icon.closest('header') || root;
      var bottom = host ? host.getBoundingClientRect().bottom : 96;
      panel.style.top = Math.max(6, Math.round(bottom) + 6) + 'px';
    }

    function open() {
      positionPanel();
      root.classList.add('is-open');
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      root.classList.remove('is-open');
      results.hidden = true;
      results.innerHTML = '';
      if (input) input.value = '';
      last = '';
    }

    /* --- Trigger: desktop enfoca; mobile toggle --- */
    if (icon) {
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        if (isDesktop()) {
          if (input) input.focus();
        } else {
          root.classList.contains('is-open') ? close() : open();
        }
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    }
    /* cerrar al tocar afuera (mobile) */
    document.addEventListener('click', function (e) {
      if (isDesktop()) return;
      if (root.classList.contains('is-open') && !root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    window.addEventListener('resize', function () {
      if (root.classList.contains('is-open')) positionPanel();
    });

    /* --- Predictivo --- */
    function fmtPrice(p) {
      var n = parseFloat(p);
      if (isNaN(n)) return '';
      return '$' + Math.round(n).toLocaleString('es-UY');
    }
    function thumb(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }
    function esc(s) {
      return String(s || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function render(prods) {
      if (!prods.length) {
        results.innerHTML = '<div class="rv-search__empty">Sin resultados</div>';
        results.hidden = false;
        return;
      }
      results.innerHTML = prods.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var media = img
          ? '<img src="' + esc(thumb(img)) + '" alt="" loading="lazy" width="44" height="52">'
          : '<span class="rv-search__ph"></span>';
        return '<a class="rv-search__result" role="option" href="' + esc(p.url) + '">' +
          media +
          '<span class="rv-search__result-title">' + esc(p.title) + '</span>' +
          '<span class="rv-search__result-price">' + fmtPrice(p.price) + '</span>' +
          '</a>';
      }).join('');
      results.hidden = false;
    }
    function query(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
          render(prods);
        })
        .catch(function () {});
    }
    var timer, last = '';
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (q === last) return;
        last = q;
        clearTimeout(timer);
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () { query(q); }, 180);
      });
      /* En desktop ocultamos resultados al perder foco (mobile usa la X / tap afuera) */
      input.addEventListener('blur', function () {
        if (isDesktop()) setTimeout(function () { results.hidden = true; }, 160);
      });
    }
    root.addEventListener('mouseleave', function () {
      if (isDesktop() && document.activeElement !== input) results.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
